/**
 * The Shopify sign-in hands its session over in cookies (see index.js), and
 * index.js re-applies them on every page load until they expire or the
 * customer signs out. A session started some other way — a gift link — must
 * remove them, or the next reload silently swaps the session back to whoever
 * last signed in through Shopify on this browser (on a shared family computer,
 * often the person who bought the gift).
 */
const SESSION_COOKIES = ["auth_token", "shopifyCustomerId", "user_email"];

export const clearShopifySessionCookies = () => {
  for (const name of SESSION_COOKIES) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
    if (process.env.REACT_APP_COOKIE_URL) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=.${process.env.REACT_APP_COOKIE_URL};`;
    }
  }
  try {
    localStorage.removeItem("shopifyCustomerId");
  } catch (_) {
    /* nothing to clear */
  }
};
